import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('div', 'passwordValidation', ['rule']);